export default "__VITE_ASSET__VeRP5O3b__"